
import React from 'react';
import { Pencil } from 'lucide-react';

export const EditIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <Pencil strokeWidth={1.5} {...props} />
);
